module.exports = __webpack_public_path__ + "static/media/icon_jrnl-blog.f18b535c.svg";